import { createContext, useContext } from 'react';

/**
 * The id of the post the answers view is drawing, for the events its controls send. Null outside
 * a post, as in a story or a test that renders a card alone, and then no event is sent.
 */
export const AnswersPostIdContext = createContext<number | null>(null);

export const useAnswersPostId = () => useContext(AnswersPostIdContext);

/** What a reference link opens, from its address. */
export function referenceLinkType(href: string): 'pubmed' | 'doi' | 'site' {
  if (/pubmed\.ncbi\.nlm\.nih\.gov/i.test(href)) {
    return 'pubmed';
  }

  return /(^|\/\/|\.)doi\.org\//i.test(href) ? 'doi' : 'site';
}
